import React from 'react';
import ImagePath from 'app/utilities/imagePath';
import { RootState } from 'app/redux/store';
import { useSelector } from 'react-redux';
import { IModalProps } from '../../interfaces/modalProps.interface';
import './ProfileModal.scss';

const ProfileModal = function init(props: IModalProps): React.ReactElement {
    const { setOpenModal } = props;
    const coorporateProfile = useSelector((state: RootState) => state.coorporateProfile);

    function closeModal(): void {
        setOpenModal(false);
    }

    return (
        <div className="profileContainer">
            <div className="titleContainer">
                <h3>Profil</h3>
                <button
                    className="imageContainer btn"
                    type="button"
                    onClick={() => closeModal()}
                >
                    <img src={ImagePath.close.src} alt={ImagePath.close.alt} />
                </button>
            </div>
            <div className="placeholder-image">
                <img src={ImagePath.placeholderImage.src} alt={ImagePath.placeholderImage.alt} />
            </div>
            <div className="verified-account-container">
                <div className="verified-account">
                    <span>Terverifikasi</span>
                </div>
                <div className="verified-account">
                    <img src={ImagePath.verifiyBadge.src} alt={ImagePath.verifiyBadge.alt} />
                </div>
            </div>
            <div className="opencapsule">
                <p>Nama Perusahaan</p>
                <span>{coorporateProfile.companyName}</span>
            </div>
            <div className="opencapsule">
                <p>Email Perusahaan</p>
                <span>{coorporateProfile.companyEmail}</span>
            </div>
            <div className="opencapsule">
                <p>Nama Lengkap PIC</p>
                <span>{coorporateProfile.picFullname}</span>
            </div>
            <div className="opencapsule">
                <p>Nomer HP PIC</p>
                <span>{coorporateProfile.phoneNumberPic}</span>
            </div>
        </div>
    );
};

export default ProfileModal;
